import { render } from "./prescriptionPayments.vue?vue&type=template&id=2b2623cf&scoped=true"
import script from "./prescriptionPayments.vue?vue&type=script&lang=js"
export * from "./prescriptionPayments.vue?vue&type=script&lang=js"

import "./prescriptionPayments.vue?vue&type=style&index=0&id=2b2623cf&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2623cf"]])

export default __exports__